import Suspense from "components/shared/Suspense";
/* eslint-disable import/no-cycle */
import { useState, lazy } from "react";
import { useIsScreenSizeBiggerThanTailwindSize } from "hooks/useIsScreenSizeBiggerThanTailwindSize";
import { CoverProps } from "hardcover-ui/theme/components/cover";
import classNames from "lib/classNames";
import Button from "hardcover-ui/components/Button";
import Icon from "hardcover-ui/components/Icon";
import faBookOpen from "icons/solid/book-open.svg";
import faTimes from "icons/solid/xmark.svg";
import LoadingDetailsSpinner from "./LoadingDetailsSpinner";

const BookDetailsPopover = lazy(() => import("./BookDetailsPopover"));

interface Props {
  bookId: number;
  size: CoverProps["size"];
  referrerId?: number;
}

export default function BookDetailsPopoverButton({
  bookId,
  size,
  referrerId,
}: Props) {
  const showPopover = useIsScreenSizeBiggerThanTailwindSize("lg");
  const [open, setOpen] = useState(false);
  const [buttonReferenceElement, setButtonReferenceElement] = useState(null);

  if (!showPopover || size === "xs") {
    return <></>;
  }

  return (
    <div
      className={classNames(
        `book-details-${bookId}`,
        "absolute w-full h-full",
        open ? "hidden lg:block" : "hidden lg:group-hover:block "
      )}
    >
      <Suspense fallback={<LoadingDetailsSpinner />}>
        <Button
          ref={setButtonReferenceElement}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setOpen((o) => !o);
          }}
          className={classNames(
            "absolute bottom-0 left-0 z-20 rounded-tr-lg transition-all",
            open
              ? "bg-card"
              : "bg-white/80 dark:bg-gray-700/80 dark:hover:bg-gray-800 hover:bg-white "
          )}
        >
          <Icon
            icon={open ? faTimes : faBookOpen}
            size="2xl"
            className="p-2 fill-gray-900 dark:fill-gray-100"
          />
        </Button>

        {open && (
          <BookDetailsPopover
            bookId={bookId}
            referrerId={referrerId}
            buttonReferenceElement={buttonReferenceElement}
            close={() => setOpen(false)}
          />
        )}
      </Suspense>
    </div>
  );
}
